import { Box, Tooltip } from '@chakra-ui/react';

import { faShieldCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@morressier/alembic';
import { useState } from 'react';

const RinggoldBadge: React.FC = () => {
  // Chakra's tooltip opens on focus as well as on hover, and `shouldWrapChildren`
  // makes the trigger focusable to allow that. Inside a modal, which focuses the
  // first focusable element when it opens, that popped this tooltip open on its
  // own. Driving `isOpen` from the pointer, with a trigger that cannot take
  // focus, keeps the tooltip to deliberate hover only.
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Tooltip
      hasArrow
      isOpen={isHovered}
      placement="top"
      label="Verified Institution by Ringgold"
      borderRadius={4}
    >
      <Box
        as="span"
        display="inline-block"
        onPointerEnter={(event: React.PointerEvent<HTMLSpanElement>) => {
          if (event.pointerType !== 'touch') {
            setIsHovered(true);
          }
        }}
        onPointerLeave={() => setIsHovered(false)}
      >
        <Badge size="context" variant="success">
          <FontAwesomeIcon icon={faShieldCheck} />
        </Badge>
      </Box>
    </Tooltip>
  );
};

export default RinggoldBadge;
